import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "@/assets/scss/material-kit.scss";
import "@/assets/app.css";
import { EmbedPlugin } from 'bootstrap-vue';
import VueLazyload from "vue-lazyload";
import VueCarousel from "vue-carousel";
import globalDirectives from "./globalDirectives";
import globalMixins from "./globalMixins";
import globalComponents from "./globalComponents";
import 'mdbvue/lib/css/mdb.min.css';

export default {
  install(Vue) {
    Vue.use(VueMaterial);
    Vue.use(VueCarousel);
    Vue.use(EmbedPlugin);
    Vue.use(globalDirectives);
    Vue.use(globalMixins);
    Vue.use(globalComponents);
    Vue.use(VueLazyload, {
      observer: true,
      // optional
      observerOptions: {
        rootMargin: "0px",
        threshold: 0.1
      }
    });
  }
};
